import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useRestoreUserGraphQL } from './useRestoreUserGraphQL';
import { useRestoreUserTRPC } from './useRestoreUserTRPC';

/**
 * Restore a previously archived non-SCIM org user, dual-routing between
 * the tRPC stack and the legacy Hasura/Apollo path based on the `trpc`
 * feature flag.
 */
export const useRestoreUser = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');
  const graphql = useRestoreUserGraphQL();
  const trpc = useRestoreUserTRPC();

  return {
    restoreUser: (userId: string) =>
      trpcEnabled ? trpc.restoreUser(userId) : graphql.restoreUser(userId),
    loading: trpcEnabled ? trpc.loading : graphql.loading,
    error: trpcEnabled ? trpc.error : graphql.error,
  };
};
